import { render } from "./TransfertArgentPage.vue?vue&type=template&id=56209c48"
import script from "./TransfertArgentPage.vue?vue&type=script&lang=js"
export * from "./TransfertArgentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__